// Dates arrive as epoch strings from GraphQL and as ISO strings from form state.
export const parseReportDate = value => {
  if (value === null || value === undefined || value === '') return null;
  const date = value instanceof Date ? new Date(value.getTime())
    : new Date(typeof value === 'string' && /^\d+$/.test(value) ? Number(value) : value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const getAssetReportingPeriod = report => {
  const end = parseReportDate(report.vs_rpt_end_date);
  const starts = (report.vs_ids || []).map(schedule => parseReportDate(schedule.vs_start_date_time)).filter(Boolean);
  const start = parseReportDate(report.vs_rpt_start_date)
    || (starts.length ? new Date(Math.min(...starts.map(date => date.getTime()))) : null);
  return { start, end };
};

// Reporting dates are UTC calendar dates even when the browser is in BST.
export const formatReportCalendarDate = value => {
  const date = parseReportDate(value);
  return date ? date.toLocaleDateString('en-GB', {
    year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC'
  }) : 'N/A';
};

export const reportCalendarDay = value => {
  const date = parseReportDate(value);
  return date ? Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()) : null;
};

export const reportDateRangeError = (start, end) => {
  const first = reportCalendarDay(start), last = reportCalendarDay(end);
  if (first === null) return 'A valid reporting Start Date is required.';
  if (last === null) return 'A valid reporting End Date is required.';
  return last <= first ? 'End Date must be after Start Date.' : '';
};

